import toast from "react-hot-toast";
import isLive from "../../api/isLive";
import loginUser from "../loginUser";

const { default: API } = require("../../api/API");

let paystackKeys = {
  test: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY_TEST,
  live: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY_LIVE,
};

let paystackKey = paystackKeys.test;

if (isLive()) {
  paystackKey = paystackKeys.live;
}

function bookService(data, onError, onReset) {
  const { first_name, last_name, email, type, create_account, password } =
    data.body;

  const { businessID, staff } = data;

  createTransaction(data).then(
    (resData) => {
      openPaystackGetway({
        ...resData,
        userDetails: {
          first_name,
          last_name,
          email,
          type,
          password,
          create_account,
        },
        businessID,
        staff,
        onReset,
      });
    },
    ({ response: { data } }) => {
      showErrorMessage(data.message)
      onError(data?.errors || []);
      if (onReset) onReset();
    }
  );
}

function createTransaction({ body = {}, businessID }) {
  return new Promise((resolve, reject) => {
    API.post(`personal/business/${businessID}/transactions`, body).then(
      resolve,
      reject
    );
  });
}

function openPaystackGetway({ userDetails, businessID, staff, onReset, ...data }) {
  const { amount_due: amount, reference: ref } = data.data.data;
  let new_amount = parseFloat(Number(amount) * 100).toFixed(2);
  if (new_amount < 0) {
    new_amount = 0;
  }
  console.log([
    {
      key: paystackKey,
      amount: new_amount,
      email: userDetails.email,
      currency: "NGN",
      firstname: userDetails.first_name,
      lastname: userDetails.last_name,
      ref,
    },
  ]);
  if (userDetails.type === "paid") {
    let handler = window.PaystackPop.setup({
      key: paystackKey,
      amount: new_amount,
      email: userDetails.email,
      currency: "NGN",
      firstname: userDetails.first_name,
      lastname: userDetails.last_name,
      ref,
      callback(response) {
        createAppointment({ reference: ref }, userDetails, businessID);
      },
      onClose() {
        // Reset submitting state when user closes the payment modal
        if (onReset) onReset();
        if (userDetails.create_account)
          loginUser({
            data: {
              email: userDetails.email,
              password: userDetails.password,
            },
            url: `/personal/#/${businessID}/business/${staff?.identifier}/${staff?.id}/staff/date`,
          });
      },
    });
    //open iframe
    handler.openIframe();
  } else {
    createAppointment({ reference: ref });
  }
}

function showLoadingOverlay() {
  const overlay = document.createElement('div');
  overlay.id = 'payment-loading-overlay';
  overlay.innerHTML = `
    <div class="loading_screen">
      <div class="loading_content">
        <img src="/favicon.ico" width="64px" alt="Loading" />
        <p>Processing your booking...</p>
      </div>
    </div>
  `;
  document.body.appendChild(overlay);
}

function hideLoadingOverlay() {
  const overlay = document.getElementById('payment-loading-overlay');
  if (overlay) {
    overlay.remove();
  }
}

function showErrorMessage(message, duration = 15000) {
  hideLoadingOverlay();
  toast.error(message || "Something went wrong. Please try again.", {
    duration,
  });
}

function createAppointment(data, userDetails, businessID) {
  return new Promise((resolve, reject) => {
    showLoadingOverlay();
    API.post(`personal/appointments`, data).then(() => {
      if (userDetails.create_account)
        loginUser({
          data: {
            email: userDetails.email,
            password: userDetails.password,
          },
        });
      else {
        //this should actually be to a success page.
        window.location.href = `/book-business/${businessID}/success`;
      }
    }).catch((error) => {
      const errorMessage = error?.response?.data?.message || "Failed to create appointment. Please try again.";
      if (errorMessage === 'business_deleted') {
        window.location.href = `/book-business/${businessID}?message=true`;
      } else {
        showErrorMessage(errorMessage);
      }
      reject(error);
    });
  });
}

export default bookService;
